import React from 'react';
import classnames from 'classnames';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { CSSTransition } from 'react-transition-group';
import animationClasses from './appear.anim.scss';
import classes from './favourite-icon.scss';
export default function FavouriteButtonIcon({
  isSelected
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FavoriteBorderIcon, {
    classes: {
      root: classnames(classes.icon, classes.white)
    }
  }), /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: animationClasses,
    in: isSelected,
    timeout: 1000
  }, /*#__PURE__*/React.createElement(FavoriteIcon, {
    classes: {
      root: classnames(classes.icon, classes.white, classes.filledIcon)
    }
  })));
}